export const LOCALE = {
    EN_US: 'en-US',
    EN_CA: 'en-CA',
    FR_CA: 'fr-CA',
} as const;

export type Locale = typeof LOCALE[keyof typeof LOCALE];
